import { CheckCircle2, CreditCard, MapPin, Truck } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { cartSeed, formatVnd } from "../../data/products";

export function CheckoutPage() {
  const [payment, setPayment] = useState("cod");
  const subtotal = cartSeed.reduce((sum, line) => sum + line.product.price * line.quantity, 0);

  return (
    <main className="page-canvas">
      <section className="container checkout-layout">
        <div className="checkout-stack">
          <div className="page-title">
            <h1>Thanh toán</h1>
            <p>Địa chỉ, giao hàng, thanh toán, VAT, coupon và đặt hàng.</p>
          </div>
          <section className="checkout-panel">
            <h2>
              <MapPin aria-hidden="true" /> Địa chỉ nhận hàng
            </h2>
            <div className="form-grid">
              <input placeholder="Họ tên" defaultValue="Nguyễn Văn Hòa" />
              <input placeholder="Số điện thoại" defaultValue="0900000000" />
              <input className="span-2" placeholder="Địa chỉ" defaultValue="Quận Bình Tân, TP.HCM" />
            </div>
          </section>
          <section className="checkout-panel">
            <h2>
              <Truck aria-hidden="true" /> Giao hàng
            </h2>
            <div className="choice-row">
              <button className="active" type="button">Giao tiêu chuẩn</button>
              <button type="button">Nhận tại kho</button>
            </div>
          </section>
          <section className="checkout-panel">
            <h2>
              <CreditCard aria-hidden="true" /> Thanh toán
            </h2>
            <div className="choice-row">
              {["cod", "transfer", "b2b"].map((method) => (
                <button
                  key={method}
                  className={payment === method ? "active" : undefined}
                  type="button"
                  onClick={() => setPayment(method)}
                >
                  {method === "cod" ? "COD" : method === "transfer" ? "Chuyển khoản" : "Công nợ B2B"}
                </button>
              ))}
            </div>
          </section>
        </div>
        <aside className="summary-panel">
          <h2>Đơn hàng</h2>
          {cartSeed.map((line) => (
            <div className="summary-row" key={line.product.id}>
              <span>{line.product.name}</span>
              <strong>{formatVnd(line.product.price * line.quantity)}</strong>
            </div>
          ))}
          <div className="summary-total">
            <span>Tổng cộng</span>
            <strong>{formatVnd(subtotal)}</strong>
          </div>
          <Link className="btn btn-primary" to="/order-success/STUT-260829-001">
            <CheckCircle2 aria-hidden="true" />
            <span>Đặt hàng</span>
          </Link>
        </aside>
      </section>
    </main>
  );
}
